const fromAppointmentBannerToCampaignInfoBanner = (appointmentBanner) => {
  let startEndDateCompound;
  if (appointmentBanner?.startEndDateCompound) {
    const { startDate, endDate } = appointmentBanner.startEndDateCompound;
    startEndDateCompound = { startDate, endDate };
  }
  return {
    startEndDateCompound,
    bannerIcon: appointmentBanner?.bannerIcon,
    bannerTitle: appointmentBanner?.bannerTitle
  };
};
const fromSpotlightedStoresContentToListBlock = (idPrefix, column) => {
  if (!column || !column.storeBlock) {
    return { title: "", links: [], id: `${idPrefix}-column` };
  }
  const { storeBlock } = column;
  const stores = storeBlock.store ?? [];
  return {
    title: storeBlock?.title ?? "",
    id: `${idPrefix}-column`,
    links: stores.filter((item) => !!item.label).map(({ url, openInNewWindow, label }, index) => ({
      label,
      url: url ?? void 0,
      openInNewWindow,
      id: `${idPrefix}-${index}-item`
    }))
  };
};
export {
  fromAppointmentBannerToCampaignInfoBanner,
  fromSpotlightedStoresContentToListBlock
};
//# sourceMappingURL=adapters.js.map
